/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

// Shared helpers for showing the signed-in user (nav + settings).
export function displayName(user) {
  return (
    user?.user_metadata?.full_name ||
    user?.user_metadata?.name ||
    (user?.email ? user.email.split("@")[0] : "Account")
  );
}

export function initialsOf(user) {
  const name = displayName(user);
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const raw = parts.length > 1 ? parts[0][0] + parts[1][0] : (parts[0] || "?").slice(0, 2);
  return raw.toUpperCase();
}

export function avatarUrl(user) {
  return user?.user_metadata?.avatar_url || "";
}
